document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".rank-math-list-item");

  if (faqItems.length > 0) {
    faqItems[0].classList.add("active");
  }
  if (faqItems.length > 1) {
    faqItems[1].classList.add("active");
  }

  faqItems.forEach((item) => {
    const question = item.querySelector(".rank-math-question");

    question.addEventListener("click", function () {
      item.classList.toggle("active");
    });
  });
});
